import { render, staticRenderFns } from "./ContactUserModal.vue?vue&type=template&id=40071342"
import script from "./ContactUserModal.vue?vue&type=script&lang=js"
export * from "./ContactUserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports